import React, { useEffect, useState } from "react";

// ASSETS
import CoverPlaceholder from "assets/img/CoverPlaceholder.png";
import { ReactComponent as NoData } from "assets/svg/NoData.svg";

// STYLES
import {
  ProjectsSectionContainer,
  ProjectsSectionWrapper,
  CirclesWrapper,
  ProjectsSectionDescriptionContainer,
  ProjectsSectionCarouselContainer,
  ProjectsSectionTextWrapper,
  ProjectsSectionTitleWrapper,
  ProjectsSectionSubtitleWrapper,
  ProjectsSectionDescriptionWrapper,
  ProjectsSectionButtonWrapper,
  NoDataContainer,
  SvgContainer,
  ArticleTitleWrapper,
} from "./ProjectsSectionStyled";

// LIBRARIES
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

// MISC
import { COLORS } from "constants/variables";
import { TextType } from "components/Atoms/CustomText/CustomTextModel";
import { ButtonType } from "components/Atoms/ButtonAtom/ButtonAtomModel";
import { appRoutes } from "config/AppRoutesConfig";
import aboutService from "services/aboutService";

// REDUX

// COMPONENTS
import ProjectsCarousel from "components/ProjectsCarousel/ProjectsCarousel";
import CirclesAtom from "components/Atoms/CirclesAtom/CirclesAtom";
import CustomText from "components/Atoms/CustomText/CustomText";
import ButtonAtom from "components/Atoms/ButtonAtom/ButtonAtom";

const ProjectsSection = () => {
  // PROPERTIES

  // LIBRARY CONSTANTS
  const navigate = useNavigate();
  const { t } = useTranslation();

  // STATE CONSTANTS
  const colors = {
    firstColor: COLORS.Background + "29",
    secondColor: COLORS.VividAuburn,
  };
  const [projects, setProjects] = useState<any>(null);

  const sizes = ["500px", "400px", "300px", "200px", "100px"];

  // API REQUESTS

  // LIFE CYCLE
  useEffect(() => {
    aboutService
      .getProjects()
      .then((response) => {
        // console.log("getProjects response", response);
        setProjects(response);
      })
      .catch((err) => {
        console.log("getProjects error", err);
      });
  }, []);

  const projectData = projects?.data
    ?.sort(
      (a, b) =>
        new Date(b.attributes.createdAt).getTime() -
        new Date(a.attributes.createdAt).getTime()
    )
    .map((project: any) => {
      return {
        id: project?.id,
        text: project?.attributes?.title,
        image:
          project?.attributes?.gallery?.data?.length > 0 &&
          project?.attributes?.cover?.data?.attributes?.url?.trim()
            ? `${process.env.REACT_APP_UPLOAD_URL}${project.attributes.cover.data.attributes.url}`
            : CoverPlaceholder,
      };
    });

  // EVENT HANDLERS

  const handleGoToProjects = () => {
    navigate(appRoutes.projects);
  };

  return (
    <ProjectsSectionContainer>
      <CirclesWrapper>
        <CirclesAtom
          sizes={sizes}
          colors={colors}
          containerTopPosition={"35px"}
          containerLeftPosition={"35px"}
        />
      </CirclesWrapper>
      {projectData != null ? (
        <ProjectsSectionWrapper>
          <ProjectsSectionDescriptionContainer>
            <ProjectsSectionTextWrapper>
              <ProjectsSectionTitleWrapper>
                <CustomText
                  text={t("view.about.aboutDSU.projectsSection.title")}
                  type={TextType.H2}
                  color={COLORS.Yellow}
                />
              </ProjectsSectionTitleWrapper>
              {/* <ProjectsSectionSubtitleWrapper>
                <CustomText
                  text={t("view.about.aboutDSU.projectsSection.subtitle")}
                  type={TextType.H2}
                  color={COLORS.Cultured}
                />
              </ProjectsSectionSubtitleWrapper> */}
              <ProjectsSectionDescriptionWrapper>
                <CustomText
                  text={t("view.about.aboutDSU.projectsSection.text")}
                  type={TextType.P1}
                  color={COLORS.Background}
                />
              </ProjectsSectionDescriptionWrapper>
            </ProjectsSectionTextWrapper>
            <ProjectsSectionButtonWrapper>
              <ButtonAtom
                text={t("view.about.aboutDSU.projectsSection.buttonText")}
                type={ButtonType.Link}
                rightIcon={true}
                onClick={handleGoToProjects}
              />
            </ProjectsSectionButtonWrapper>
          </ProjectsSectionDescriptionContainer>

          <ProjectsSectionCarouselContainer>
            <ProjectsCarousel data={projectData} />
          </ProjectsSectionCarouselContainer>
        </ProjectsSectionWrapper>
      ) : (
        <ProjectsSectionWrapper>
          <NoDataContainer>
            <SvgContainer>
              <NoData />
            </SvgContainer>
            <ArticleTitleWrapper>
              <CustomText
                text={t("app.noData")}
                type={TextType.H4}
                color={COLORS.Cultured}
              />
            </ArticleTitleWrapper>
          </NoDataContainer>
        </ProjectsSectionWrapper>
      )}
    </ProjectsSectionContainer>
  );
};

export default ProjectsSection;
